module.exports = __webpack_public_path__ + "static/img/rebel_pictgrid28_1060x864.e6a511f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/rebel_pictgrid28_1060x864.jpg
// module id = aB0o
// module chunks = 0